import React, {
  useCallback, useEffect, useState,
} from 'react';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  ContainerPrincipal,
} from './ValidarProcessoStyles';
import LoadingUI from '../../components/UI/Loading/LoadingUI';
import Grid24 from '../../components/UI/Grid24';
import { ButtonUI } from '../../components';
import { validarProcessoFactory } from './ValidarProcessoFactory';
import { useValidarProcessoDispatch, useValidarProcessoSelector } from '../../store/ValidarProcesso/ValidarProcessoProvider';
import { setSimpleValidarProcessoAction, setSimpleValuesListIdsAction } from '../../store/ValidarProcesso/ValidarProcesso.store';
import { extractResponseErrorMessage, getNewPage } from '../../helpers';
import { buscarDadosTabelaAction, exportarValidacaoProcessosAction, proximaFaseProcessoAction } from '../../store/ValidarProcesso/ValidarProcesso.saga';
import TabelaValidarProcessos from './TabelaValidarProcessos';
import DialogNew from '../../layouts/FormDialog/DialogNew';
import DialogEnviarProcessosOutraFase from '../../components/Processos/Pesquisa/AcoesPesquisaProcesso/DialogEnviarProcessosOutraFase/DialogEnviarProcessosOutraFase';
import useStyle from '../../components/Processos/Pesquisa/AcoesPesquisaProcesso/AcoesPesquisaProcesso,.styles';

function ValidarProcessoComponent() {
  const dispatch = useValidarProcessoDispatch();
  const styles = useStyle();

  const [conteudoTabela, setConteudoTabela] = useState([]);
  const [openEnviarProcessosOutraFase, setOpenEnviarProcessosOutraFase] = useState(false);

  const loading = useValidarProcessoSelector(states => states.common.loadingPage);
  const page = useValidarProcessoSelector(states => states.page);
  const rowsPerPage = useValidarProcessoSelector(states => states.rowsPerPage);
  const totalElements = useValidarProcessoSelector(states => states.totalElements);
  const tableView = useValidarProcessoSelector(states => states.tableView);
  const listIds = useValidarProcessoSelector(states => states.listIds);
  const selectAll = useValidarProcessoSelector(states => states.selectAll);

  const changeSelectAll = useCallback((e) => {
    const { checked } = e.target;
    dispatch(setSimpleValidarProcessoAction('selectAll', checked));
    dispatch(setSimpleValidarProcessoAction('listIds', Object.keys(listIds).reduce((acc, key) => ({ ...acc, [key]: checked }), {})));
  }, [listIds, dispatch]);

  const changePageHandler = useCallback((event, newPage) => {
    dispatch(setSimpleValidarProcessoAction('page', Number(newPage)));
    dispatch(setSimpleValidarProcessoAction('tableView', tableView));
    dispatch(buscarDadosTabelaAction(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const changeRowsPerPageHandler = useCallback((e) => {
    const size = e.target.value;
    const newPage = getNewPage(rowsPerPage, page, size);

    dispatch(setSimpleValidarProcessoAction('page', Number(newPage)));
    dispatch(setSimpleValidarProcessoAction('rowsPerPage', Number(size)));
    dispatch(setSimpleValidarProcessoAction('tableView', tableView));
    dispatch(buscarDadosTabelaAction(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, rowsPerPage, page]);

  const changeSelectId = useCallback((e) => {
    const { name, checked } = e.target;
    dispatch(setSimpleValuesListIdsAction(name, checked));
  }, [dispatch]);

  const onClickAlterarFase = useCallback(() => {
    setOpenEnviarProcessosOutraFase(true);
  }, []);

  const onClickProximaFase = useCallback(() => {
    dispatch(proximaFaseProcessoAction());
  }, [dispatch]);

  const onClickExportar = useCallback(() => {
    dispatch(exportarValidacaoProcessosAction());
  }, [dispatch]);

  const onClickAtualizar = useCallback(() => {
    dispatch(buscarDadosTabelaAction(true));
  }, [dispatch]);

  const onConfirmAlterarFase = useCallback((open) => {
    setOpenEnviarProcessosOutraFase(open);
    dispatch(buscarDadosTabelaAction(true));
  }, [dispatch]);

  async function goToInspecaoProcesso(idProcesso) {
    try {
      window.open(`/processos/inspecao?nroProcesso=${idProcesso}`, '_blank');
    } catch (error) {
      toast.error(extractResponseErrorMessage(error),
        { style: { width: '392px' } });
    }
  }

  async function goToDevedorProcesso(idProcesso) {
    try {
      window.open(`/processos/inspecao?nroProcesso=${idProcesso}&nroAba=3`, '_blank');
    } catch (error) {
      toast.error(extractResponseErrorMessage(error),
        { style: { width: '392px' } });
    }
  }

  async function goToAntecedentesProcesso(idProcesso) {
    try {
      window.open(`/processos/inspecao?nroProcesso=${idProcesso}&nroAba=2`, '_blank');
    } catch (error) {
      toast.error(extractResponseErrorMessage(error),
        { style: { width: '392px' } });
    }
  }

  useEffect(() => {
    setConteudoTabela(validarProcessoFactory.makeConteudoTabela(
      tableView,
      changeSelectId,
      listIds,
      goToInspecaoProcesso,
      goToDevedorProcesso,
      goToAntecedentesProcesso,
    ));
  }, [tableView, changeSelectId, listIds]);


  useEffect(() => {
    dispatch(buscarDadosTabelaAction(true));
    dispatch(setSimpleValidarProcessoAction('tableView', tableView));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return (
    <>
      <DialogNew
        open={openEnviarProcessosOutraFase}
        text="Enviar Processos para outra Fase"
        className={styles.dialogEnviarProcessosParaOutraFase}
      >
        <DialogEnviarProcessosOutraFase
          processosSelecionados={
            Object.keys(listIds).filter(key => listIds[key] === true).map(key => Number(key))
          }
          processosMesmaFase={false}
          faseProcessos={null}
          processosPermitemFaseCobrancaPresencial
          setOpenDialog={onConfirmAlterarFase}
          processosTemAgendamento={false}
          processosTemRequisicao={false}
          simpleSearchFormRef={null}
          advancedSearchRef={null}
        />
      </DialogNew>
      <ContainerPrincipal>
        <LoadingUI show={loading} />
        <Grid24 container isFormContainer spacing="1" style={{ marginBottom: '16px' }}>
          <Grid24 item xs={24} sm={12}>
            <ButtonUI
              style={{ width: '120px' }}
              color="white"
              disabled={Object.values(listIds).filter(value => value === true).length === 0}
              onClick={() => { onClickAlterarFase(); }}
            >
              Alterar Fase
            </ButtonUI>
            <ButtonUI
              style={{ width: '120px', marginLeft: '10px' }}
              color="white"
              disabled={Object.values(listIds).filter(value => value === true).length === 0}
              onClick={() => { onClickProximaFase(); }}
            >
              Próx. Fase
            </ButtonUI>
            <ButtonUI
              style={{ width: '120px', marginLeft: '10px' }}
              color="white"
              onClick={() => { onClickExportar(); }}
            >
              Exportar
            </ButtonUI>
            <ButtonUI
              style={{ width: '120px', marginLeft: '10px' }}
              color="white"
              onClick={() => { onClickAtualizar(); }}
            >
              Atualizar
            </ButtonUI>
          </Grid24>
          <Grid24 item xs={24} sm={24}>
            <TabelaValidarProcessos
              columns={validarProcessoFactory.makeCabecalhoTabela(
                changeSelectAll, selectAll,
              )}
              rows={conteudoTabela}
              page={page}
              size={totalElements}
              rowsPerPageOptions={[10, 15, 20]}
              rowsPerPage={rowsPerPage}
              onChangePage={changePageHandler}
              onChangeRowsPerPage={changeRowsPerPageHandler}
            />
          </Grid24>
        </Grid24>
      </ContainerPrincipal>
    </>
  );
}

export const ValidarProcesso = withRouter(ValidarProcessoComponent);
